// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Injectable<T = any, U extends any[] = any, V = any> = {
  (...args: U): V
  inject: (deps: Partial<T> | ((d: T) => Partial<T>)) => Injectable<T, U, V>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const depend = <T extends Record<string, any>, U extends any[], V>(
  dependencies: T,
  cb: (deps: T, ...args: U) => V,
): Injectable<T, U, V> => {
  const fn = (...args: U) => cb(dependencies, ...args)

  fn.inject = (deps: Partial<T> | ((d: T) => Partial<T>)) =>
    typeof deps === 'function'
      ? depend({ ...dependencies, ...deps(dependencies) }, cb)
      : depend({ ...dependencies, ...deps }, cb)

  return fn
}
